var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"text-center",attrs:{"flat":"","tile":""}},[_vm._v("\n  "+_vm._s(("" + (_vm.contenidoMayor({
      item: _vm.Articulo[0],
    }))))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }